'use client'

import { useEffect, useRef, useState } from 'react'

export const useRefRevertInfiniteScroll = (
  fetch: (oldScrollHeight: number) => void,
  listenerCallback: () => void,
  list: unknown[],
  isLoadingInit = false,
) => {
  const refBox = useRef<HTMLInputElement>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isInitEnd, setIsInitEnd] = useState(false)
  useEffect(() => {
    if (isInitEnd && !isLoadingInit) {
      handleScroll()
    }
  }, [isInitEnd, isLoadingInit])

  useEffect(() => {
    if (refBox.current && !isInitEnd) {
      init()
    }
  }, [refBox?.current, list])

  useEffect(() => {
    if (!isLoadingInit) {
      refBox.current?.addEventListener('scroll', handleScroll)
      return () => {
        refBox.current?.removeEventListener('scroll', handleScroll)
      }
    }
  }, [isLoadingInit])

  const reset = () => {
    setIsLoading(false)
    setIsInitEnd(false)
  }

  const endFetch = (oldScrollHeight: number) => {
    if (refBox.current) {
      refBox.current.scrollTop = refBox.current.scrollHeight - oldScrollHeight
      setIsLoading(false)
    }
  }

  const init = () => {
    refBox.current?.scrollIntoView({ behavior: 'instant' })
    const scrollHeight = refBox.current?.scrollHeight

    if (scrollHeight && refBox.current) {
      refBox.current.scrollTop = scrollHeight
    }

    setIsInitEnd(true)
  }

  const handleScroll = () => {
    if (!isLoading && refBox.current && refBox.current.scrollTop < 40) {
      setIsLoading(true)

      fetch(refBox.current.scrollHeight - refBox.current.scrollTop)
    }

    listenerCallback()
  }

  return { endFetch, refBox, reset }
}
